/*
 * WEEE / Compliance Block v2.0 — toggle behaviour.
 *
 * Wires every [data-weee-block] on the page so its toggle button shows
 * and hides the panel below. Vanilla JS, no dependencies, idempotent.
 *
 * Lifecycle: re-attaches on shopify:section:load (theme customiser),
 * removes listeners on shopify:section:unload. Mirrors the resilience
 * pattern used by custom-stock-block.js and open-source-design.js.
 */

(function () {
  if (window.__weeeNoticeInit) return;
  window.__weeeNoticeInit = true;

  const handlers = new WeakMap();

  function wireBlock(blockEl) {
    if (!blockEl || handlers.has(blockEl)) return;

    const button = blockEl.querySelector('[data-weee-toggle]');
    const panel = blockEl.querySelector('[data-weee-panel]');
    if (!button || !panel) return;

    const onClick = function () {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      button.setAttribute('aria-expanded', String(next));
      if (next) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    };

    button.addEventListener('click', onClick);
    handlers.set(blockEl, { button, onClick });
  }

  function unwireBlock(blockEl) {
    const entry = handlers.get(blockEl);
    if (!entry) return;
    entry.button.removeEventListener('click', entry.onClick);
    handlers.delete(blockEl);
  }

  function wireAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-weee-block]').forEach(wireBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wireAll(document); });
  } else {
    wireAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { wireAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-weee-block]').forEach(unwireBlock);
  });
})();
